var routerMixins = {};
routerMixins.cutRoute = function (path) {
  for (var x = path.length - 1; x > -1; x--) {
    if (path[x] === '/') {
      return path.substr(0, x);
    }
  }
};

routerMixins.extractRoute = function (path) {
  for (var x = path.length - 1; x > -1; x--) {
    if (path[x] === '/') {
      return path.substr(x, path.length);
    }
  }
};

export default routerMixins;
